import React from 'react';
import { useSiteMetadata } from '@src/lib';

interface SEOProps {
  title?: string;
  pathname?: string;
  children?: string;
  baseTitle?: string;
  page?: string;
  description?: string;
}

export function SEO(props: SEOProps) {
  const { title = 'TCGL', pathname, children, description = '', page } = props;
  const { title: defaultTitle, description: defaultDescription, image, siteUrl, twitterUsername } = useSiteMetadata();

  const pageTitle = `${title}${page ? ` - ${page}` : ''}`;

  const seo = {
    title: pageTitle || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name='description' content={seo.description} />
      <meta name='image' content={seo.image} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:url' content={seo.url} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:creator' content={seo.twitterUsername} />
      <link rel='icon' href='../../../images/favicon.png' />
      {children}
    </>
  );
}
